import * as service from "../service";
import { store } from "../../store";
import type { ServiceResponse } from "../types";

/**
 * Count the events the current student has subscribed to.
 * Backend: GET /api/user/subscripted/countSubscripted
 */
export const CountSubscriptedAPI = async (): Promise<ServiceResponse<number>> => {
  const { user } = store.getState().auth as any;
  try {
    const resp = await service.call(
      "GET",
      "api/user/subscripted/countSubscripted",
      {
        user_id: user?.id,
      },
    );
    return resp;
  } catch (err) {
    console.error(`CountSubscriptedAPI ${err}`);
    return { status: -1 };
  }
};
